import { RouteConfig } from 'vue-router';
import ConsultaLegislacao from '@/views/legislacao/ConsultaLegislacao.vue';
import LegislacaoSelecionada from '@/views/legislacao/LegislacaoSelecionada.vue';

const baseRouterLink = '/legislacao';

const LegislacaoNormasRoutes: RouteConfig[] = [
  {
    path: `${baseRouterLink}/consulta`,
    name: 'consulta-legislacao',
    component: ConsultaLegislacao,
  },
  {
    path: `${baseRouterLink}/find/:cdLegislacao`,
    name: 'legislacao-selecionada',
    component: LegislacaoSelecionada,
  },
];

export default LegislacaoNormasRoutes;
